<template>
    <apex-chart type="bar" height="350" :options="c_options" :series="c_series"></apex-chart>
</template>

<script>
import ApexChart from 'vue-apexcharts'
import moment from 'moment'
export default {
    props:{
        statistics:Object,
    },
    components:{
        ApexChart,
    },
    data(){
        return{
            colors:["#1F4690","#36AE7C","#EF5B0C","#ff9f43"]
        }
    },
    computed:{
        c_options(){
            let options = {
                chart:{toolbar: {show:false},},
                plotOptions: { bar: { horizontal: false, columnWidth: '55%', }, },
                dataLabels: { enabled: false },
                stroke: { show: true,  width: 2, colors: ['transparent'] },
                xaxis: { categories: this.statistics?.StatsByDate?.map(item=> moment(item.CreateDate).locale("tr").format("L")) || [], },
                yaxis: { labels: { formatter: function(val) { return Number(val) }}},
                tooltip: { y: { formatter: function (val) { return val + "₺" }}},
                fill: { opacity: 1 },
            }
            return options
        },
        c_series(){
            return [{
                name:this.statistics?.Plate,
                color:"#1F4690",
                data:this.statistics?.StatsByDate?.map(s=>parseFloat(s.TotalAmountWithoutTax.replace(".","").replace(",","."))) || []
            }]
        }
    }
}
</script>

<style>

</style>